<template>
    <div class="cards-content">
        <fcwpArchiveCard 
            v-for="(item, index) of content"
            :key="index"
            :card="item"
            class="card"
            :class="[item.thumb ? (item.type == 'doc' ? 'card-full' : 'card-big') : 'card-small', item.class]"
        ></fcwpArchiveCard>
    </div>
</template>


<script>
import fcwpArchiveCard from './fcwpArchiveCard.vue'
export default {
    name: 'fcwpArchiveContent',
    props: ['content'],
    components: {
        fcwpArchiveCard,
    }
}
</script>